import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { SubmissionError, reset } from 'redux-form';

import { formatValidationErrors } from '../common/utils/getApiReducer';
import Icon from '../common/icons/Icon';
import { Modal } from 'synfrastructure';
import AddForm from '../common/forms/AddForm';
import DeleteForm from '../common/forms/DeleteForm';
import { addCourse, deleteCourse } from './actions';

class CourseListPage extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    courses: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      addCourseModalVisible: false,
      deleteCourseId: null,
      deleteCourseModalVisible: false,
      deleteCourseName: null,
    };
  }

  toggleAddCourseModal = () => {
    this.setState(state => ({ addCourseModalVisible: !state.addCourseModalVisible }));
  };

  toggleDeleteCourseModal = (id, name) => {
    if (this.state.deleteCourseModalVisible) {
      this.setState(state => ({
        deleteCourseId: null,
        deleteCourseModalVisible: false,
        deleteCourseName: null,
      }));
    } else {
      this.setState(state => ({
        deleteCourseId: id,
        deleteCourseModalVisible: true,
        deleteCourseName: name,
      }));
    }
  };

  onAddCourseSubmit = values => {
    const { dispatch } = this.props;

    return dispatch(addCourse(values)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.props.history.push(`/courses/${action.json.id}`);
      }
    });
  };

  onDeleteCourseSubmit = () => {
    const { dispatch } = this.props;

    return dispatch(deleteCourse(this.state.deleteCourseId)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.toggleDeleteCourseModal();
        dispatch(reset('deleteForm'));
      }
    });
  };

  render() {
    const { courses } = this.props;
    const { addCourseModalVisible, deleteCourseModalVisible, deleteCourseName } = this.state;

    return (
      <div className="admin-paper">
        <Modal isVisible={addCourseModalVisible} onClose={this.toggleAddCourseModal}>
          <AddForm entityType="Course" onSubmit={this.onAddCourseSubmit} onCancel={this.toggleAddCourseModal} />
        </Modal>
        <Modal isVisible={deleteCourseModalVisible} onClose={this.toggleDeleteCourseModal}>
          <DeleteForm
            entityType="Course"
            onSubmit={this.onDeleteCourseSubmit}
            onCancel={this.toggleDeleteCourseModal}
            requiredConfirmationText={deleteCourseName}
          />
        </Modal>
        <div className="admin-paper__header">
          <h3>Courses</h3>
          <button onClick={this.toggleAddCourseModal} className="admin__add-button">
            <Icon icon="Plus" />Add Course
          </button>
        </div>
        <ul className="admin-paper__list">
          {courses.get('data').size ? (
            courses.get('data').map(course => (
              <li key={`course-${course.get('id')}`}>
                <div className="admin-paper__list__title">
                  <Icon icon="Flag" />
                  {course.get('name')}
                </div>
                <div className="admin-paper__list__actions">
                  <Link to={`/courses/${course.get('id')}`}>
                    <Icon icon="Pencil" />
                  </Link>
                  <span
                    className="delete"
                    onClick={this.toggleDeleteCourseModal.bind(this, course.get('id'), course.get('name'))}
                  >
                    <Icon icon="Trash" />
                  </span>
                </div>
              </li>
            ))
          ) : (
            <div className="admin-paper__no-content">There are currently no courses</div>
          )}
        </ul>
      </div>
    );
  }
}

export default connect(state => ({
  courses: state.courses.courses,
}))(CourseListPage);



// WEBPACK FOOTER //
// ./src/courses/CourseListPage.js